import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    defaultAriaLabel: 'Chevron Down Icon',
};

export const ChevronDownCviIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.0051 18.005C11.7778 18.005 11.5597 17.9147 11.399 17.754L4.53686 10.8918C4.20213 10.5571 4.20213 10.0144 4.53686 9.67962C4.8716 9.34488 5.41431 9.34488 5.74905 9.67962L12.0051 15.9357L18.2611 9.67962C18.5958 9.34488 19.1385 9.34488 19.4733 9.67961C19.808 10.0143 19.808 10.5571 19.4733 10.8918L12.6112 17.7539C12.4504 17.9147 12.2324 18.005 12.0051 18.005Z"
            />
        </SvgIcon>
    );
};
